<template>
  <div class="container" v-if="isShow">
    <div class="vote">
      <span class="icontemp stemp-close" @click="close"></span>
      <iframe frameborder="0" :src="src"></iframe>
    </div>
  </div>
</template>

<script>
import {
  buildQuestionData,
  buildQuestionMethod,
  mounted
} from "../../common/question";
export default {
  name: "Question",
  data() {
    return buildQuestionData({
      type: "pc"
    });
  },
  created() {
    let self = this;
    mounted(self);
  },
  methods: buildQuestionMethod({})
};
</script>

<style scoped></style>
